module.exports = __webpack_public_path__ + "img/station-wagon.4622da5c.svg";